/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IGetMarketTrandResponse } from '../../entities/market_trand/GetMarketTrandResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetMarketTrandRequest {
  period: EQueryParameters;
  realtyId: number;
  roomsCount: EQueryParameters_1;
}

export enum EQueryParameters {
  /** 1 месяц **/
  'OneMonth' = 'oneMonth',
  /** 6 месяцев **/
  'SixMonths' = 'sixMonths',
  /** 1 год **/
  'OneYear' = 'oneYear',
  /** 2 года **/
  'TwoYears' = 'twoYears',
  /** Все вермя **/
  'All' = 'all',
}
export enum EQueryParameters_1 {
  /** Однокомнатная квартира **/
  'OneRoom' = 'oneRoom',
  /** Двухкомнатная квартира **/
  'TwoRooms' = 'twoRooms',
  /** Трехкомнатная квартира **/
  'ThreeRooms' = 'threeRooms',
  /** Четырехкомнатная квартира + другие **/
  'FourPlusRooms' = 'fourPlusRooms',
  /** Студия **/
  'Studio' = 'studio',
  /** Все квартиры **/
  'All' = 'all',
}
export type TGetMarketTrandResponse =
  | FetchModelResponse<200, 'json', IGetMarketTrandResponse>
  | FetchModelResponse<400, 'json', IErrorResponseSchema>;

export type TGetMarketTrandModel = IFetchModel<IGetMarketTrandRequest, undefined, TGetMarketTrandResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetMarketTrandResponse, headers: Headers): TResponse200;
  400(response: IErrorResponseSchema, headers: Headers): TResponse400;
}
